export const COURSE_OUTCOME_1_FONT_FAMILY_MAP_VARIANT_1 = {
  preTitle: "var(--font-poppins)",
  title: "var(--font-poppins)",
  description: "var(--font-poppins)",
  loadMore: "var(--font-poppins)",
  cardMetaTitle: "var(--font-poppins)",
  cardMetaDescription: "var(--font-poppins)",
  cardBoxTitle: "var(--font-poppins)",
  cardBoxSubTitle: "var(--font-poppins)",
} as const;

export const COURSE_OUTCOME_1_FONT_FAMILY_MAP_VARIANT_2 = {
  preTitle: "var(--font-google-sans)",
  title: "var(--font-merriweather)",
  description: "var(--font-google-sans)",
  loadMore: "var(--font-google-sans)",
  cardMetaTitle: "var(--font-google-sans)",
  cardMetaDescription: "var(--font-google-sans)",
  cardBoxTitle: "var(--font-merriweather)",
  cardBoxSubTitle: "var(--font-google-sans)",
} as const;

export type CourseOutcome1FontFamilyMap =
  | typeof COURSE_OUTCOME_1_FONT_FAMILY_MAP_VARIANT_1
  | typeof COURSE_OUTCOME_1_FONT_FAMILY_MAP_VARIANT_2;

export const COURSE_OUTCOME_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: 1,
    meta_title: "Wealth Manager / Private Banker",
    meta_title_color: "#56E2F5",
    meta_description: "",
    meta_description_color: "#FFFFFF",
    meta_box_color: "#FFFFFF",
    meta_box_title: "20-30 LPA",
    meta_box_title_color: "#342B7C",
    meta_box_sub_title: "Avg Salary",
    meta_box_sub_title_color: "#222222",
    priority: 1,
  },

  COURSE_OUTCOME_FIELDS_CONFIG: [
    {
      fieldName: "pre_title",
      label: "Pre Title",
      value: "Where This Program",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Pre Title (e.g., Where This Program)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "pre_title_text_color",
      label: "Pre Title Text Color",
      value: "#FFFFFFCC",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter pre title text color (e.g., #FFFFFFCC)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "title",
      label: "Title",
      value: "Can Take You",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title (e.g., Can Take You)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "title_gradient_angle",
      label: "Title Gradient Angle",
      value: "90deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter gradient angle (e.g., 90deg, 180deg)",
      required: false,
      defaultValue: "90deg",
    },
    {
      fieldName: "title_gradient_start_color",
      label: "Title Gradient Start Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_gradient_end_color",
      label: "Title Gradient End Color",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#00D4EB",
      required: false,
      defaultValue: "#00D4EB",
    },
    {
      fieldName: "description",
      label: "Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Description",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "description_color",
      label: "Description Color",
      value: "#FFFFFFB2",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter description color (e.g., #FFFFFFB2)",
      required: false,
      defaultValue: "#000000",
    },
    // {
    //   fieldName: "load_more_button",
    //   label: "Load More Button Text",
    //   value: "Load More",
    //   valueType: "string",
    //   filedType: "INPUT",
    //   placeholder: "Enter Load More button text",
    //   required: false,
    //   defaultValue: "Load More",
    // },
    // {
    //   fieldName: "load_more_button_text_color",
    //   label: "Load More Button Text Color",
    //   value: "#FFFFFF",
    //   valueType: "string",
    //   filedType: "COLOR",
    //   placeholder: "Enter Load More button text color",
    //   required: false,
    //   defaultValue: "#FFFFFF",
    // },
    {
      fieldName: "backvariant",
      label: "Background Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Background Variant",
      required: true,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
        { label: "Variant 3", value: "variant_3" },
      ],
    },
    {
      fieldName: "font_family_variant",
      label: "Font Family",
      value: "variant_2",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select font family",
      required: false,
      defaultValue: "variant_2",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
      ],
    },
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop background color (e.g., #ffffff)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile Background Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile background color (e.g., #ffffff)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "rgba(0, 212, 235, 0.33)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 1",
      required: false,
      defaultValue: "rgba(0, 212, 235, 0.33)",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "rgba(0, 0, 0, 0.66)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 2",
      required: false,
      defaultValue: "rgba(0, 0, 0, 0.66)",
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "rgba(0, 0, 0, 0.66)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 3",
      required: false,
      defaultValue: "rgba(0, 0, 0, 0.66)",
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "rgba(83, 69, 195, 0.46)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 4",
      required: false,
      defaultValue: "rgba(83, 69, 195, 0.46)",
    },
    // {
    //   fieldName: "background_variant",
    //   label: "Background Variant",
    //   value: "1",
    //   valueType: "string",
    //   filedType: "SELECT",
    //   placeholder: "Select background variant",
    //   required: false,
    //   defaultValue: "1",
    //   options: [
    //     { label: "Background 1", value: "1" },
    //     { label: "Background 2", value: "2" },
    //     { label: "Background 3", value: "3" },
    //   ],
    // },
    {
      fieldName: "status",
      label: "Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Course Outcome Section",
      defaultValue: false,
    },
    {
      fieldName: "enable_animation",
      label: "Enable Animation",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable animation",
      required: false,
      defaultValue: false,
    }
  ],

  METADATA_FIELDS: [
    {
      header: "Title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Career Title (e.g., Wealth Manager / Private Banker)",
      required: false,
    },
    {
      header: "Title Color",
      fieldName: "meta_title_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title color (e.g., #000000)",
    },
    {
      header: "Description",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Career Description",
    },
    {
      header: "Description Color",
      fieldName: "meta_description_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter description color (e.g., #000000)",
    },
    {
      header: "Box Background Color",
      fieldName: "meta_box_color",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter box background color (e.g., #ffffff)",
    },
    {
      header: "Box Title",
      fieldName: "meta_box_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Box Title",
    },
    {
      header: "Box Title Color",
      fieldName: "meta_box_title_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter box title color (e.g., #000000)",
    },
    {
      header: "Box Sub Title",
      fieldName: "meta_box_sub_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Box Sub Title",
    },
    {
      header: "Box Sub Title Color",
      fieldName: "meta_box_sub_title_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter box sub title color (e.g., #000000)",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
  ]
};
